import type { OptionDB } from "@project/emerge";
import { Sides } from "@project/emerge-types";
import { Covers } from "../enum/Covers";
import { LTProducts } from "../enum/LTProducts";
import type { FlightCaseSettings } from "../interfaces/FlightCaseSettings";
import { FlightCaseDefinition } from "../products/FlightCaseDefinition";
import {
  createCoverOptions,
  createRackInterior,
} from "../structure/RackInterior";

export class DoubleDoorCase extends FlightCaseDefinition {
  public static getSerializedDefaultVersion(
    optionDb: OptionDB,
  ): FlightCaseSettings {
    const result: FlightCaseSettings =
      FlightCaseDefinition.getSerializedDefaultVersion(optionDb);
    result.type = LTProducts.DoubleDoor;
    result.exteriorOptions.strength = 6.5;
    result.cuts = [
      {
        offset: 50,
        reference: Sides.FRONT,
        groupName: Covers.FRONT_COVER,
      },
      {
        offset: 50,
        reference: Sides.BACK,
        groupName: Covers.BACK_COVER,
      },
    ];
    result.variableOptions = [];
    result.interiorOptions = createRackInterior();
    result.coverPaddings = createCoverOptions(result.cuts);
    return result;
  }
}
